import * as React from "react";
import { forwardRef } from "react";
const SvgSync = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 14, height: 14, viewBox: "0 0 14 14", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M11.365 4a6.94 6.94 0 0 0-6.49 4.448l1.076.438A5.784 5.784 0 0 1 15.995 7.5H13.7v1.167h4.083V4.583h-1.168v1.8A6.96 6.96 0 0 0 11.365 4m5.414 9.115a5.78 5.78 0 0 1-5.414 3.719A5.84 5.84 0 0 1 6.716 14.5h2.315v-1.167H4.948v4.083h1.167v-1.8a6.96 6.96 0 0 0 11.74-2.06z", "data-name": "icon/sync", transform: "translate(-4.375 -4)", fill: "#98a9bc" }));
const ForwardRef = forwardRef(SvgSync);
export { ForwardRef as ReactComponent };
